import script from "./danh-sach-session.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-session.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-session.vue?vue&type=style&index=0&id=48d71f58&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d71f58"]])

export default __exports__